import React, { lazy, Suspense } from "react";
import { Spin } from "antd";
import { usePermission } from "app/hooks/usePermission";

const Forbidden = lazy(() => import("app/containers/Forbidden"));

/**
 * PermissionRoute - Wraps a page component and checks if the current user
 * has the required permission code to access it.
 *
 * Usage:
 *   <Route path="/news" element={<PermissionRoute code="news"><News /></PermissionRoute>} />
 *
 * If the user lacks the permission, renders the Forbidden page instead.
 */
const PermissionRoute = ({ code, children }) => {
  const { hasPermission } = usePermission();

  if (!code || hasPermission(code)) {
    return children;
  }

  return (
    <Suspense fallback={<Spin size="large" />}>
      <Forbidden />
    </Suspense>
  );
};

export default PermissionRoute;
